import { css, Theme } from "@emotion/react";

export const MemberMenuStyle = {
  self: css`
    padding: 50px 0;
    list-style: none;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 5px;
  `,

  menuItem: css`
    width: 100%;
    display: block;
    margin-bottom: 40px;
    a,
    button {
      width: 100%;
      height: 100%;
      text-decoration: none;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: inherit;
      text-align: center;
      border: none;
      svg {
        height: 35px;
      }
    }
  `,
  menuTitle: ({ fontSize, colors }: Theme) => css`
    color: ${colors.orange[100]};
    margin-top: 20px;
    font-size: ${fontSize[14]};
    line-height: 20px;
    text-transform: capitalize;
  `,
  menuIcon: ({ colors }: Theme) => css`
    path {
      fill: ${colors.orange[100]};
    }
  `,
};
